import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import { Grid, styled, Typography } from "@mui/material";
import { api } from "api";
import { assignmentResultCSV } from "api/types";
import { AssignmentChipStatus } from "components/AssignmentChipStatus";
import { RealmTag } from "components/RealmTag";
import { StyledButton } from "components/StyledButton";
import { Assignment } from "helpers/assignment";
import { formatDateStr } from "helpers/date";
import React, { useRef, useState } from "react";
import { CSVLink } from "react-csv";
import { Link } from "react-router-dom";

const PREFIX = "AssignmentDashboardPageListItem";

const classes = {
	root: `${PREFIX}-root`,
	tag: `${PREFIX}-tag`,
	date: `${PREFIX}-date`,
	titleTagContainer: `${PREFIX}-titleTagContainer`,
	overflowContainer: `${PREFIX}-overflowContainer`,
};

const StyledPaper = styled(Grid)(({ theme }) => ({
	[`&.${classes.root}`]: {
		width: "100%",
		background: theme.palette.background.paper,
		padding: theme.spacing(2),
		borderRadius: theme.spacing(1),
	},
	[`& .${classes.tag}`]: {
		background: theme.palette.primary.main,
		color: "white",
		borderRadius: 15,
		marginRight: 5,
		float: "left",
		marginTop: "5px",
	},
	[`& .${classes.titleTagContainer}`]: {
		flexGrow: "true",
		justifyContent: "space-between",
	},
	[`& .${classes.overflowContainer}`]: {
		marginTop: "-5px",
	},

	[`& .${classes.date}`]: {
		padding: 5,
		marginLeft: 5,
		float: "left",
	},
}));

export interface AssignmentListModelItemProps {
	assignment: Assignment;
	labelId: string;
	getPath: (assignmentId: string) => string;
	setErr: any;
	show: boolean;
}

export const AssignmentModelListItem = ({
	assignment,
	labelId,
	getPath,
	setErr,
	show,
}: AssignmentListModelItemProps): JSX.Element => {
	const csvRef = useRef<
		CSVLink & HTMLAnchorElement & { link: HTMLAnchorElement }
	>(null);
	const [data, setData] = useState<assignmentResultCSV[]>([]);
	const [loading, setloading] = useState(false);
	const handleCSV = (assignmentId: string): assignmentResultCSV[] => {
		if (!loading) {
			setloading(true);
		}
		api
			.GetAssignmentResultCSV(assignmentId)
			.then((res) => {
				if (res.status !== 200) {
					throw new Error();
				}

				setloading(false);
				setData(res.data);
				csvRef?.current?.link.click();

				return res.data;
			})
			.catch(() => {
				setErr("No result for this assignment");
			});
		setloading(false);
		return [];
	};
	return (
		<StyledPaper
			data-testid={labelId}
			className={classes.root}
			container
			spacing={2}
		>
			<Grid item xs={6}>
				<Grid
					container
					flexDirection="row"
					className={classes.titleTagContainer}
				>
					<Typography align="left">{assignment.name}</Typography>
					<Grid item className={classes.overflowContainer}>
						{assignment.activities
							.filter(
								(ass, index, arr) =>
									arr.findIndex((a) => a.realm === ass.realm) === index,
							)
							.map((a, idx) => (
								<RealmTag key={a.realm + idx.toString()} name={a.realm} />
							))}
					</Grid>
				</Grid>
			</Grid>
			<Grid item xs={3}>
				<AccessAlarmIcon fontSize="large" className={classes.date} />
				<Typography className={classes.date}>
					{formatDateStr(assignment.endDate)}
				</Typography>
			</Grid>
			<Grid item xs={3}>
				<Grid
					container
					flexDirection="row"
					className={classes.titleTagContainer}
				>
					<AssignmentChipStatus label={assignment.status} />
					{show ? (
						<Grid item className={classes.overflowContainer}>
							<StyledButton
								variant="contained"
								// component={Link}
								// to={getPath(assignment.assignmentId)}
								data-testid="download-csv-btn"
								style={{ marginTop: "5px" }}
								onClick={() => handleCSV(assignment.assignmentId)}
							>
								Download csv
							</StyledButton>
							<CSVLink filename={assignment.name} data={data} ref={csvRef} />
						</Grid>
					) : null}
					<Grid item className={classes.overflowContainer}>
						<StyledButton
							variant="contained"
							component={Link}
							to={getPath(assignment.assignmentId)}
							data-testid="view-asg-btn"
							style={{ marginTop: "5px" }}
						>
							View
						</StyledButton>
					</Grid>
				</Grid>
			</Grid>
		</StyledPaper>
	);
};
